import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { statusBillingsType } from 'src/app/types/response/billings-response.type';

@Component({
  selector: 'app-modal-auto-subscribe',
  standalone: false,
  templateUrl: './modal-auto-subscribe.component.html',
  styleUrls: ['./modal-auto-subscribe.component.scss']
})
export class ModalAutoSubscribeComponent {
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  @Input() statusData: statusBillingsType = {}

  constructor(private modal: NzModalRef) { }

  onConfirm(): void {
    this.confirm.emit();
    this.modal.close('confirm');
  }

  onCancel(): void {
    this.cancel.emit();
    this.modal.close('cancel');
  }
}
